import { groupCompositionCompareItemValidationSchema } from '../../../../shared/raids';
import { IGetGroupCompositionCompareParams, IGroupCompositionCompareResult } from '../../../../shared/types/raidTypes';
import { apiServiceAsync } from '../../services/apiService';
import { createQueryModule } from './utils';

export const GROUP_COMPOSITION_COMPARE_STATE_KEY = 'groupCompositionCompare';

export const groupCompositionCompareModule = createQueryModule<
  IGroupCompositionCompareResult,
  IGetGroupCompositionCompareParams
>({
  prefix: 'RAIDING/GROUP_COMPOSITION_COMPARE',
  stateKey: GROUP_COMPOSITION_COMPARE_STATE_KEY,
  fetchFn: (params) => {
    return apiServiceAsync.getGroupCompositionCompare(params);
  },
  isParamsValid: (params) => {
    const someItemIsValid = params.items.some(
      (item) => groupCompositionCompareItemValidationSchema.validate(item).error === undefined
    );

    return someItemIsValid;
  }
});
